import Http from 'axios'
import qs from 'qs'
import CryptoJS from 'crypto-js'
// import { UserInfo } from '../tools'
let CRYPTOJSKEY = 'V6VJTOYa3Ga1k6mwpm'
Http.defaults.baseURL = '/'
// Http.defaults.baseURL = 'https://wechat.rigintouch.cn'

Http.defaults.timeout = 300000
// Http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
Http.defaults.headers.post['Content-Type'] = 'application/json'

// 请求类
class ApiService {
  constructor () {
    this.interceptorsOfReq()
    this.interceptorsOfRes()
  }
  
  download(url, params){
    if (params) {
      return Http.get(url, { params })
    }
    return Http.get(url)
  }
  get (url, params) {
    if (params) {
      return Http.get(url, { params }).then(res => res.data)
    }
    return Http.get(url).then(res => res.data)
  }

  doPost (url, para = {}) {
    return Http.post(url, qs.stringify(para, { encode: false })).then(res => res.data)
  }

  post (url, para = {}) {
    return Http.post(url, para).then(res => res.data)
  }
  postJson (url, para = {}) {
    if(para){
      para.headers= {
        'content-type': 'application/json'
      }
    }
    return Http.post(url, para).then(res => res.data)
  }
  put (url, para = {}) {
    return Http.put(url, qs.stringify(para, { encode: false })).then(res => res.data)
  }

  delete (url, para = {}) {
    return Http.delete(url, {data: para}).then(res => res.data)
  }

  interceptorsOfReq () {
    return Http.interceptors.request.use(
      config => {
        // if(config.data){
        //   let api={
        //       url:config.url,
        //       data:config.data,
        //       method:config.method
        //   }
        //   const key = "385f33cb91484b04a177828829081ab7";  //十六位十六进制数作为密钥
        //   const iv = '37fa77f6a3b0462d'; 
        //   var l = CryptoJS.enc.Utf8.parse( JSON.stringify(api));
        //   var e = CryptoJS.enc.Utf8.parse(key);
        //   var a = CryptoJS.AES.encrypt(l, e, {
        //       mode: CryptoJS.mode.CBC,
        //       padding: CryptoJS.pad.Pkcs7,
        //       iv: CryptoJS.enc.Utf8.parse(iv)
        //   })
        //   config.data = {data:a.ciphertext.toString()};
        // }else{
        //   config.data = {data:''};
        // }
        // debugger
        let api={
            url:config.url,
            data:config.data,
            method:config.method,
            responseType:config.responseType||'json',
            headers: {
              'content-type': 'application/json',
          },
        }
        if(config.headers){
          api.headers = {...api.headers,...config.headers};
        }
        console.log(api);
        if(api.method!="post"){
          delete api.headers;
        }
        const key = "385f33cb91484b04a177828829081ab7";  //十六位十六进制数作为密钥
        const iv = '37fa77f6a3b0462d'; 
        var l = CryptoJS.enc.Utf8.parse( JSON.stringify(api));
        var e = CryptoJS.enc.Utf8.parse(key);
        var a = CryptoJS.AES.encrypt(l, e, {
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            iv: CryptoJS.enc.Utf8.parse(iv)
        })
        config.data = {data:a.ciphertext.toString()};
        config.url="/api/forward"
        return config
      },
      err => {
        return Promise.reject(err)
      })
  }

  interceptorsOfRes () {
    Http.interceptors.response.use(function (response) {
      if(response.data){

      
        if(response.data.data && response.data.data.length>10){
          const key = "385f33cb91484b04a177828829081ab7";  //十六位十六进制数作为密钥
          const iv = '37fa77f6a3b0462d'; 
  
          var e = CryptoJS.enc.Utf8.parse(key);
          var WordArray = CryptoJS.enc.Hex.parse(response.data.data);  // 如果text是base64形式，该行注释掉
          var text = CryptoJS.enc.Base64.stringify(WordArray);  // 如果text是base64形式，该行注释掉
          var a = CryptoJS.AES.decrypt(text, e, {
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7,
              iv: CryptoJS.enc.Utf8.parse(iv)
          });
          let res =CryptoJS.enc.Utf8.stringify(a).toString();
          console.log(res);
          if(res.length>0){
            response.data = JSON.parse(res);
          }
        }
      }
      return response
    }, function (error) {
      return Promise.reject(error)
    })
  }
  
}

// 导出一个对象
export default new ApiService()



// WEBPACK FOOTER //
// ./src/APIService/http.js